import { productSchema } from './product.js';

/**
 * Offer product schema
 * @param {object} data
 * @param {object} data.cart Object with raw cart data from eStore API
 * @param {object} data.payment Object returned from payment schema
 * @param {number} data.index Index of the item in the array
 * @param {object} data.item Item from eStore API
 * @param {object} data.sessionStore Session store instance
 * @param {string} [data.offerType] crossSell, upsell or undefined
 * @returns {object}
 */
export const offerSchema = ({ cart, payment, index, item, sessionStore, offerType }) => {
	if (!item) {
		return null;
	}
	const productSchemaResponse = productSchema({
		cart,
		payment,
		index,
		item,
		sessionStore,
		offerType
	});
	return {
		...productSchemaResponse,
		list: 'Cross-pop',
		offerType
	};
};
